{
  "main": {
    "welcome": "Привет от {company}!",
    "new_messages": "0 машин | {n} машина | {n} машины | {n} машин",
    "appeal":"Написать обращение",
    "appeal_content": "Есть о чём рассказать? Создай новость через нашего бота в Telegram!",
    "full_lang": {
      "en": "English",
      "ru": "Русский",
      "uz": "O'zbekcha",
      "uz-to": "Ўзбекча"
    },
    "short_lang": {
      "en": "En",
      "ru": "Ру",
      "uz": "O'z",
      "uz-to": "Ўз"
    },
    "live_stream": "Прямой эфир",
    "sum": "сум",
    "sections": "рубрики",
    "all": "все",
    "main": "главная",
    "categories": "категории",
    "contacts": "контакты",
    "information": "Информация",
    "more": "Подробнее",
    "return": "вернуться",
    "read_also": "Читайте также"
  },
  "footer": {
    "disclaimer_text": "Для использования новостей на сайте требуется письменное согласие",
    "founder": "Учредитель",
    "certificate": "Свидетельство",
    "date_issued": "Дата выдачи"
  },
  "not-found": {
    "not-found": "такая страница не существует либо была удалена"
  },
  "search_bar": {
    "input_placeholder": "Поиск",
    "result": "Результаты по запросу",
    "result_not_first": "По запросу",
    "result_not": "ничего не найдено",
    "sort_new": "Сначала новые",
    "sort_old": "Сначала старые",
    "recomend": "Рекомендации для вас:"
  },
  "months": {
    "january": "Январь",
    "february": "Февраль",
    "march": "Март",
    "april": "Апрель",
    "may": "Май",
    "june": "Июнь",
    "july": "Июль",
    "august": "Август",
    "september": "Сентябрь",
    "october": "Октябрь",
    "november": "Ноябрь",
    "december": "Декабрь"
  },
  "days": {
    "today": "Сегодня",
    "yesterday": "Вчера",
    "0": "Воскресенье",
    "1": "Понедельник",
    "2": "Вторник",
    "3": "Среда",
    "4": "Четверг",
    "5": "Пятница",
    "6": "Суббота"
  },
  "video_player": {
    "volume": "Громкость",
    "start_pauza": "Старт/Пауза",
    "mini_screen": "Мини-проигрыватель",
    "full_screen": "Широкий экран"
  },
  "error": {
    "error": "ошибка",
    "search": "Вы можете воспользоваться поиском чтобы найти интересующую вас новость",
    "orback": "или вернуться на предыдущую страницу",
    "input": "Поиск ...",
    "nothing-found": "Ничего не найдено"
  },
  "sayt_test": {
    "saytTest": "Сайт работает в тестовом режиме"
  },
  "routes": {
    "LiveStream": "Прямой эфир",
    "404": "Не найдено",
    "Search": "Поиск",
    "SearchQuery": "Поиск {query}",
    "NewsDetail": "Zamon новости",
    "FeedWrapper": "Лента Zamon новости",
    "MainWrapper": "{category} Zamon новости",
    "StaffDetail": "Детали персонала",
    "AccountSettings": "Настройки аккаунта",
    "CreateArticles": "Создать статью",
    "EditArticle": "Редактировать статью",
    "PreferredLang": "Создать статью",
    "Articles": "Статьи",
    "StaffPage": "Команда Замон",
    "LogIn": "Вход",
    "Registration": "Регистрация",
    "Recovery": "Восстановление пароля"
  },
  "authorization": {
    "enter": "Войти",
    "registration": "Регистрация",
    "login": "Логин",
    "password": "Пароль",
    "wronglogin": "* Неверный логин",
    "wrongpassword": "Забыли пароль?",
    "forogtPassword": "забыли пароль?",
    "mainPage": "Вернуться на главную",
    "name": "Имя",
    "surname": "Фамилия",
    "phone": "Номер телефона",
    "email": "Эл-адресс",
    "continue": "Продолжить",
    "realName": "Введите своё настоящее имя",
    "realsurname": "Введите свою настоящую фамилию",
    "enterPhone": "Введите номер телефона",
    "entermail": "Введите свой адрес электронной почты",
    "emptyArea": "*Это поле обязательно для заполнения",
    "newPassword": "Придумайте пароль",
    "createNewPassword": "Придумайте новый пароль",
    "replyNewPassword": "Повторите пароль",
    "back": "Назад",
    "needLogin": "Логин потребуется вам для входа",
    "passwordLength": "Пароль должен содержать не менее шести чисел, букв и знаков препинания",
    "showPassword": "*Пароль слишком короткий‎‎",
    "passwordMismatch": "*Пароли не совпадают",
    "busyLogin": "*Логин «Onegin» занят‎‎",
    "infPassport": "Добавьте фотографию паспорта",
    "contentPassport": "*Фотография должна быть хорошего качества, без бликов и теней на паспорте, с хорошо читаемой информацией ",
    "completeRegister": "Регистрация завершена",
    "getImage": "Перетащите изображение",
    "selectImage": "Выбрать...",
    "imageFormat": "JPG, PNG",
    "image": "Фото",
    "message": "После прохождения валидации мы отправим на ваш E-mail ссылку на для входа в личный кабинет.",
    "validation": "Валидация займёт от 1 до 3 рабочих дней",
    "clear": "Понятно",
    "resetPassword": "Сбросить пароль",
    "passwordRecovery": "Восстановление пароля",
    "mailMessage": " Введите свой адрес электронной почты ниже, и мы отправим вам лектронное письмо с инструкциями по созданию нового пароля.",
    "yourMail": "Ваш E-mail",
    "resetEmail": "* Введите адрес эл.почты указанный при регистрации",
    "instruction": "На вашу почту отправлено письмо с инструкцией по созданию нового пароля",
    "saveChanges": "Сохранить изменения",
    "verifyTitle": "Код подтверждения отправлен в СМС на номер который вы указали при регистрации",
    "verification_code_invalid": "Неправильный код подтверждения",
    "confirmCode": "Код подтверждения",
    "repeatCode": "Отправить код снова",
    "confirmCodeBtn": "Подтвердить код",
    "humanPassportTitle": "Добавьте фотографию с открытым паспортом как показано на картинке → ",
    "explanation": "*Фото должно быть хорошего качества. Не допускаются фото в солнцезащитных очках, лицо должно быть хорошо освещено",
    "overlay": "Завершить регистрацию"
  },
  "world": {
    "world_population": "Численность населения"
  },
  "staff_page": {
    "count_news": "Новостей",
    "count_views": "Просмотров",
    "about_me": "О себе",
    "last_news": "Последние статьи:",
    "journalists": "Журналисты",
    "employees": "Сотрудники",
    "news_card": {
      "title": "В Ташкенте прошёл ежегодный фестиваль электронной музыки",
      "data": "08.05.2021, 22:57",
      "category": "Подкатегория"
    }
  },
  "header": {
    "new_news": "Создать новость",
    "auth": "Авторизация",
    "appeal": "Написать обращение"
  },
  "news__detail": {
    "share": "поделиться ссылкой",
    "share_facebook": "поделиться в facebook",
    "share_instagram": "поделиться в instagram",
    "share_telegram": "поделиться в telegram",
    "share_title": "поделиться:",
    "tags_title": "теги:"
  },
  "sport": {
    "math_started": "Матч начался"
  },
  "time": {
    "hour_ago": "ч.",
    "minute_ago": "мин.",
    "ago": "назад"
  },
  "uzbekistan": {
    "selectCountry": "Выберите регион чтобы увидеть его последние новости:",
    "close": "Закрыть",
    "karakalpakistan": "Республика Каракалпакстан",
    "khorezm": "Хорезмская область",
    "navoi": "Навоийская область",
    "bukhara": "Бухарская область",
    "samarkand": "Самаркандская область",
    "karshi": "Кашкадарьинская область",
    "jizzax": "Джизакская область",
    "surkhandarya": "Сурхандарьинская область",
    "sirdarya": "Сырдарьинская область",
    "tashkent": "Ташкент",
    "namangan": "Наманганская область",
    "fergana": "Ферганская область",
    "andijan": "Андижанская область"
  },
  "admin": {
    "admin": "Админ",
    "profile": "Редактирование профиля",
    "changepassword": "Изменить пароль",
    "changed_profile": "Успешно изменен",
    "return": "Вернуться",
    "username": "Имя",
    "surname": "Фамилия",
    "userlogin": "Логин",
    "usermail": "Эл. почта",
    "userbio": "О себе",
    "infbio": "Добавьте информацию о себе",
    "maxwords": "* Максимум 150 символов",
    "примен": "Применить",
    "currentpassword": "Введите старый пароль",
    "userpassword": "Введите новый пароль",
    "replypassword": "Повторите новый пароль",
    "length": "Пароль должен содержать не менее восьми цифр, букв и знаков препинания.",
    "video": "Это обязательное поле",
    "repeatable_fields": "оглавление и подкатегория существует",
    "title": "Добавление новости",
    "prevLang": "Создание новостей на",
    "changeLang": "*Чтобы опубликовать новость на узбекском языке нужно написать её в двух вариантах - на латинице и кириллице",
    "lang": "язике",
    "latinlang": "Заполните",
    "latinlangOne": "поля",
    "latin": "латиницей",
    "kr": "кириллицей",
    "comment": "Пожалуйста, исправьте ошибки ниже",
    "contentTitle": "Оглавление:",
    "brief": "Бриф:",
    "description": "описание",
    "media": "Видео материал:",
    "image": "Рисунок:",
    "atMoment": "В данный момент:",
    "selectFile": "Выберите файл",
    "delete": "удалить",
    "tags": "Теги:",
    "avialable": "Доступные теги",
    "selected": "Выбранные теги",
    "country": "выберите страну",
    "regions": "выберите регион",
    "selectedRegions": "Выбранная область",
    "selectedCountry": "Выбранная страна",
    "regions_selected":"Выберите хотя бы один тег региона",
    "country_selected":"Выберите хотя бы один тег страна",
    "search": "Поиск",
    "filter": "Фильтр",
    "commandControl": "Удерживайте Control (или Command на Mac), чтобы выбрать несколько значений.",
    "selectAll": "Выбрать все",
    "removeAll": "Удалить все",
    "newsCategory": "Категория новостей:",
    "status": "Статус новостей:",
    "draft": "Черновик",
    "date": "Дата публикации:",
    "explanationDate": "Дата и время когда будет опубликована новость",
    "editing": "Сохранить и продолжить редактирование",
    "save": "Сохранить",
    "addedNews": "Добавлено новостей:",
    "views": "Общее кол-во просмотров:",
    "add_news": "Добавить новость",
    "go_out": "Выйти",
    "home": "К новостям",
    "changeIMage": "Изменить фото",
    "published_news": "Опубликованные новости",
    "moderation": "Ожидающие модерацию",
    "rejected": "Отклоненные новости",
    "drafts": "Черновики",
    "redactor": "Редактировать",
    "Go_to": "Перейти",
    "change_language": "Изменить язык",
    "in_en":"На Английском",
    "in_ru":"На Русском",
    "in_uz":"На Узбекском",
    "choose_lang": "Выберите на каком языке Вы будете добавлять новости",
    "success_msg": "Новость успешно отправлена на модерацию",
    "not_published": "У Вас нет опубликованных новостей на выбранном языке",
    "mediaToTg": "Медиа в Телеграм",
    "msgToTg": "Сообщение в Телеграм",
    "videoToTg": "Видео в Телеграм"
  },
  "super_user": {
    "title": "Выберите новость для изменений",
    "set_page": "Перейти",
    "news_count": "Новостей",
    "search": "Найти",
    "filter": "Фильтр",
    "id": "ID",
    "news_title": "ОГЛАВЛЕНИЕ",
    "news_author": "АВТОР НОВОСТЕЙ",
    "news_category": "КАТЕГОРИЯ НОВОСТИ",
    "news_date": "ДАТА ПУБЛИКАЦИИ",
    "news_status": "СТАТУС НОВОСТИ",
    "draft": "ЧЕРНОВИК",
    "move": "показано",
    "from": "из",
    "clear": "очистить все фильтры",
    "from_date": "с даты",
    "to_date": "По дату",
    "reset": "Сбросить",
    "all": "Все",
    "yes": "Да",
    "no": "Нет"
  }
}